import { checkFont } from '@common/components/func';
import { IMultiSelect } from '@common/types/element';
import { isEmpty, pick } from 'lodash';
import { Platform, StyleSheet } from 'react-native';

const createStyles = (attributes: IMultiSelect) => {
  return StyleSheet.create({
    container: {
      ...pick(attributes, [
        'borderColor',
        'borderRadius',
        'backgroundColor',
        'opacity',
      ]),

      shadowColor: attributes?.shadow?.color || '#fff',
      shadowRadius: attributes?.shadow?.size || 0,
      shadowOpacity: attributes?.shadow?.blur || 0,
      shadowOffset: {
        width: attributes?.shadow?.x || 0,
        height: attributes?.shadow?.y || 0,
      },
      elevation: attributes?.shadow?.size || 0,
      ...(!isEmpty(attributes.borderStyle) && {
        borderStyle:
          attributes.borderStyle === 'none' ? 'solid' : attributes.borderStyle,
      }),
    },
    checkboxItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 8,
      paddingHorizontal: 4,
    },
    checkboxText: {
      marginLeft: 8,
      fontSize: attributes.fontSize,
      color: attributes.color,
      flex: 1,
      ...(Platform.OS !== 'web' && {
        fontFamily: checkFont(attributes?.fontFamily),
      }),
      lineHeight:
        Platform.OS === 'web' ? undefined : attributes.fontSize * 1.15,
    },
    selectAllItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 8,
      paddingHorizontal: 4,
      borderBottomWidth: 1,
      borderBottomColor: attributes.borderColor || '#e0e0e0',
      marginBottom: 8,
    },
    selectAllText: {
      marginLeft: 8,
      fontSize: attributes.fontSize,
      color: attributes.color,
      fontWeight: 'bold',
      flex: 1,
      ...(Platform.OS !== 'web' && {
        fontFamily: checkFont(attributes?.fontFamily),
      }),
    },
    headerContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 12,
    },
    selectedCountText: {
      fontSize: attributes.fontSize * 0.9,
      color: attributes.color,
      opacity: 0.7,
    },
    clearButton: {
      paddingHorizontal: 8,
      paddingVertical: 4,
    },
    clearButtonText: {
      fontSize: attributes.fontSize * 0.9,
      color: attributes.color,
      textDecorationLine: 'underline',
    },
    maxSelectionsText: {
      fontSize: attributes.fontSize * 0.8,
      color: attributes.color,
      opacity: 0.6,
      textAlign: 'center',
      marginTop: 8,
      fontStyle: 'italic',
    },
    loadMoreContainer: {
      padding: 16,
      alignItems: 'center',
    },
  });
};

export default createStyles;
